var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var toNumber = function (value) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
};
var sumOf = function (rows, pick) { return rows.reduce(function (total, row) { return total + toNumber(pick(row)); }, 0); };
var errorEntryOf = function (reason, entry) {
    return typeof entry === "number"
        ? { reason: reason, count: entry, policies: [] }
        : {
            reason: reason,
            count: toNumber(entry === null || entry === void 0 ? void 0 : entry.count),
            policies: Array.isArray(entry === null || entry === void 0 ? void 0 : entry.policies) ? entry.policies : [],
        };
};
var addRejections = function (totals, entries, kind) {
    entries.forEach(function (_a) {
        var _b, _c;
        var reason = _a.reason, count = _a.count, policies = _a.policies;
        if (count <= 0)
            return;
        var key = "".concat(kind, ":").concat(reason);
        var current = totals.get(key);
        totals.set(key, {
            reason: reason,
            kind: kind,
            count: ((_b = current === null || current === void 0 ? void 0 : current.count) !== null && _b !== void 0 ? _b : 0) + count,
            policies: __spreadArray(__spreadArray([], ((_c = current === null || current === void 0 ? void 0 : current.policies) !== null && _c !== void 0 ? _c : []), true), policies, true),
        });
    });
};
var rejectionsOf = function (rows) {
    var totals = new Map();
    rows.forEach(function (row) {
        var _a, _b, _c, _d;
        addRejections(totals, Object.entries((_b = (_a = row.summary) === null || _a === void 0 ? void 0 : _a.errorsByCode) !== null && _b !== void 0 ? _b : {}).map(function (_a) {
            var reason = _a[0], entry = _a[1];
            return errorEntryOf(reason, entry);
        }), "error");
        addRejections(totals, Object.entries((_d = (_c = row.summary) === null || _c === void 0 ? void 0 : _c.skippedByReason) !== null && _d !== void 0 ? _d : {}).map(function (_a) {
            var reason = _a[0], entry = _a[1];
            return errorEntryOf(reason, entry);
        }), "skipped");
    });
    return Array.from(totals.values()).sort(function (a, b) {
        return a.kind === b.kind ? b.count - a.count : a.kind === "error" ? -1 : 1;
    });
};
export var toCollectionSummaryData = function (rows) {
    if (rows.length === 0)
        return null;
    return {
        policiesCount: sumOf(rows, function (row) { return row.emittedCount; }),
        amountToCollect: sumOf(rows, function (row) { return row.totalAmount; }),
        cardsCount: sumOf(rows, function (row) { return row.cardCount; }),
        accountsCount: sumOf(rows, function (row) { return row.accountCount; }),
        rejections: rejectionsOf(rows),
    };
};
export var resolveCollectionSummaryState = function (request) {
    if (!request.collectionId)
        return { status: "hidden" };
    if (request.error || !request.data)
        return { status: "hidden" };
    return { status: "ready", data: request.data };
};
